import React        from "react"
import { render }   from "react-dom"
import Application  from './routes/application'

render <Application />, document.getElementById "app"
